import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__icons">
        <a
          href="https://www.linkedin.com/in/rohan-kumar-a65a87175/"
          target="_blank"
          rel="noreferrer"
          className="footer__icons-link"
        >
          <img
            className="footer__icons-icon"
            src="https://img.icons8.com/color/48/000000/linkedin.png"
            alt="linkedin"
          />
        </a>
        <a
          href="https://github.com/rohan220217"
          target="_blank"
          rel="noreferrer"
          className="footer__icons-link"
        >
          <img
            className="footer__icons-icon"
            src="https://img.icons8.com/color/48/000000/github--v1.png"
            alt="Github"
          />
        </a>
        <a
          href="https://stackoverflow.com/users/13182435/rohan"
          target="_blank"
          rel="noreferrer"
          className="footer__icons-link"
          >
          <img
            className="footer__icons-icon"
            src="https://img.icons8.com/color/48/000000/stackoverflow.png"
            alt="Stackoverflow"
          />
        </a>
        <a href="tel:+91 7374091655" className="footer__icons-link">
          <img
            className="footer__icons-icon"
            src="https://img.icons8.com/color/48/000000/apple-phone.png"
            alt="Phone"
          />
        </a>
      </div>
      <ul className="footer__nav">
        <a href="#about" className="footer__nav-item">
          <li>About</li>
        </a>
        <a href="#skills" className="footer__nav-item">
          <li>Skills</li>
        </a>
        <a href="#work" className="footer__nav-item">
          <li>Work</li>
        </a>
        <a href="#education" className="footer__nav-item">
          <li>Education</li>
        </a>
        <a href="#contact" className="footer__nav-item">
          <li>Contact</li>
        </a>
      </ul>
    </footer>
  );
}

export default Footer;
